<template>
  <div class="score">
    <div class="container">
      <div v-if="gameData != null">
        <Summary :summary="gameData"/>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Summary from "../components/Summary.vue";

export default {
  name: 'scorecard',
    components : {
      Summary
    },
    computed: {
    },
    data () {
        return {
          debugMode: (process.env.VUE_APP_DEBUG_MODE === "true" ? true : false),
          publicPath: process.env.BASE_URL,
          gameData: null,
          isLoading: true
        }
    },
    methods:{
      getScorecardById: function(scorecard_id) {
        var url = (this.debugMode ? "http://localhost:8080/scorecard/" : "https://axes2api.azurewebsites.net/scorecard/")
        url += scorecard_id;
        var token = this.$parent.getApiToken();

        axios.get(url,{
            headers: {
                authorization: token
            }
        })
        .then((response) => {
          this.gameData = response.data;
          this.isLoading = false;
          console.log("got data");
        }, (error) => {
          alert(error);
        });
      },
    },
    mounted(){
      var id = this.$route.params.scorecard_id;
      //alert("loading summary for scorecard id: " + id);
      this.getScorecardById(id);
      console.log("SummaryViewer mounted");
    }
}
</script>

<style lang="scss" scoped>
.score {
  background-color: white;
  overflow-y: auto;
}
</style>